// eslint-disable-next-line import/no-anonymous-default-export
export default {
	neutral: {
		30: '#FCFCFC',
		50: '#F9FAFB',
		70: '#F5F7F8',
		100: '#F0F4F6',
		200: '#E2E9ED',
		250: '#d6dde3',
		300: '#BDC5CB',
		400: '#8B9298',
		500: '#4B5055',
		600: '#383F48',
		700: '#272F3C',
		800: '#192030',
		900: '#101628',
	},
	primary: {
		50: '#F5F9FE',
		70: '#E5EFFF',
		100: '#DAE8FD',
		200: '#B5CFFB',
		300: '#8EB1F4',
		400: '#6F95E9',
		500: '#436EDB',
		600: '#3054BC',
		700: '#213D9D',
		800: '#152A7F',
		900: '#0C1C69',
	},
	secondary: {
		50: '#FAF6FE',
		70: '#FEF0FF',
		100: '#F3E9FD',
		200: '#E7D4FC',
		300: '#D5BCF6',
		400: '#C3A7EC',
		500: '#A989E1',
		600: '#8264C1',
		700: '#5F45A2',
		800: '#412B82',
		900: '#2B1A6C',
	},
	success: {
		50: '#F0FFF4',
		70: '#dbf6e3',
		100: '#C6F6D5',
		200: '#9AE6B4',
		300: '#68D391',
		400: '#48BB78',
		500: '#38A169',
		600: '#2F855A',
		700: '#276749',
		800: '#22543D',
		900: '#1C4532',
	},
	info: {
		50: '#F5FDFF',
		100: '#D8F9FF',
		200: '#B2EFFF',
		300: '#8BE0FF',
		400: '#6FD0FF',
		500: '#3FB5FF',
		600: '#2E8EDB',
		700: '#1F6AB7',
		800: '#144B93',
		900: '#0C357A',
	},
	warning: {
		50: '#FFFDF5',
		100: '#FFF6CD',
		200: '#FFEA9B',
		300: '#FFDB6A',
		400: '#FFCC45',
		500: '#FFB407',
		600: '#DB9305',
		700: '#B77503',
		800: '#935A02',
		900: '#7A4601',
	},
	danger: {
		50: '#FFEDEC',
		100: '#FFE7D9',
		200: '#FFCAB3',
		300: '#FFA68D',
		400: '#FF8371',
		500: '#FF4B42',
		600: '#DB3036',
		700: '#B72133',
		800: '#93152E',
		900: '#7A0C2C',
	},
};
